






import {computed, ComputedRef, defineComponent} from "@vue/composition-api";

export default defineComponent({
  name: "AtomButton",
  props: {
    name: {type: String, required: true},
    primary: {type: Boolean, default: false},
    type: {
      String,
      validator: (value: any) => {
        return ["icon", "close"].includes(value)
      }
    },
    size: {
      String,
      validator: (value: any) => {
        return ["small", "medium", "large"].includes(value)
      }
    }
  },
  setup: (props) => {
    const classes: ComputedRef<object> = computed(() => {
      return {
        'vuw-align-center': true,
        'vuw-button': !props.type,
        [`vuw-${props.type}-button`]: props.type,
        'vuw-icon-button--primary': props.primary && props.type == "icon",
        [`vuw-icon-button--${props.size}`]: props.type == "icon",
        'vuw-bg-support-5': !props.primary && !props.type,
        'vuw-bg-primary-1 vuw-text-support-5': props.primary && !props.type
      };
    });
      
    return {
      classes
    };
  }
})
